<div class="scrollable-form-container d-flex">
    <form *ngIf="activeForm" [formGroup]="activeForm" class="form form-container">
      <div >
          <div class="trigger-header pb-3">
              <b>{{ 'TRIGGER.ALARM' | translate }}</b>
              <div class="header-divider mt-2"></div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4 pb-3">              
                <div class="channel-body">              
                    <div class="row-item-width-50 input-group input-container">
                        <label for="yellowAlertValue" class="input-label"><img src="icon/yellow.svg" /> <img src="icon/notification.svg" /></label>
                        <input class="input-field" id="yellowAlertValue" name="test" formControlName="yellowAlertValue" />
                        <span class="unit">mm/s</span>

                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4 pb-3">              
                <div class="channel-body">              
                    <div class="row-item-width-50 input-group input-container">
                        <label for="orangeAlertValue" class="input-label"><img src="icon/orange.svg" /> <img src="icon/notification.svg" /></label>
                        <input class="input-field" id="orangeAlertValue" name="test" formControlName="orangeAlertValue" />
                        <span class="unit">mm/s</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4 pb-3">              
                <div class="channel-body">              
                    <div class="row-item-width-50 input-group input-container">
                        <label for="redAlertValue" class="input-label"><img src="icon/red.svg" /> <img src="icon/notification.svg" /></label>
                        <input class="input-field" id="redAlertValue" name="test" formControlName="redAlertValue" />
                        <span class="unit">mm/s</span>
                    </div>
                </div>
            </div>
          </div>
  
          
        <div class="pb-3">
        </div>
      </div>
  
      <div formArrayName="emailsThreshold">
        <div class="trigger-header pb-3">
          <b>{{ 'TRIGGER.EMAILS' | translate }}</b>
          <div class="header-divider mt-2"></div>
      </div>
      <div *ngFor="let email of emailsThreshold.controls; let i = index" [formGroupName]="i" class="pb-3">
        <div class="email-item d-flex align-items-center">
          <div class="switch me-2">
            <input type="checkbox" formControlName="isActive" id="switch-email-{{ i }}" />
            <label for="switch-email-{{ i }}"></label>
          </div>
      
          <input class="input-field me-3" type="email" formControlName="email" placeholder="Email" />
      
          <!-- Alarm level buttons -->
          <div class="alarm-buttons d-flex me-3">
            <div
              class="alarm-circle"
              [class.selected]="email.get('alarm')?.value === 0"
              (click)="onAlarmClick(email, 0)"
              title="Yellow"
            >
              <img src="icon/yellow.svg" /><img src="icon/notification.svg" />
            </div>
            <div
              class="alarm-circle"
              [class.selected]="email.get('alarm')?.value === 1"
              (click)="onAlarmClick(email, 1)"
              title="Orange"
            >
              <img src="icon/orange.svg" /><img src="icon/notification.svg" />
            </div>
            <div
              class="alarm-circle"
              [class.selected]="email.get('alarm')?.value === 2"
              (click)="onAlarmClick(email, 2)"
              title="Red"
            >
              <img src="icon/red.svg" /><img src="icon/notification.svg" />
            </div>
          </div>
      
          <button class="btn btn-sm btn-light" type="button" (click)="removeEmail(i)">
            <img src="icon/delete.svg" />
          </button>
        </div>
      </div>
      
        
        <div class="pb-3">
          <button class="btn btn-sm btn-light me-3" type="button" (click)="addEmail()"><img src="icon/add-circle.svg" class="me-2"/>{{ 'TRIGGER.NEW_EMAIL' | translate }}</button>
        </div>
        
      </div>
  <div>
      
  </div>
  
    </form>
      <div class="fixed-submit-container">
          <button *ngIf="isFormChanged" class="fixed-cancel-button btn btn-sm btn-light me-3" (click)="resetForm()" type="button">Cancel</button>
          <button class="fixed-submit-button btn btn-light me-3 colored-button me-3" type="submit"  (click)="submitForm()"><img src="icon/save.svg" class="me-2" 
              />{{ 'TRIGGER.SAVE' | translate }}</button>
      </div>
      
  
  </div>



